import { FilterStatus } from '../../../common/enums/FilterStatus';
import { Severity } from '../../../common/enums/Severity';

export class Issue {
  constructor(
    private readonly issueNumber: number,
    private readonly title: string,
    private readonly shortExplanation: string,
    private readonly severity: Severity,
    private readonly filterStatus: FilterStatus,
    private readonly reportId: number,
    private readonly instances: number[]
  ) {}

  getNumber() {
    return this.issueNumber;
  }

  getTitle() {
    return this.title;
  }

  getShortExplanation() {
    return this.shortExplanation;
  }

  getSeverity() {
    return this.severity;
  }

  getFilterStatus() {
    return this.filterStatus;
  }

  getReportId() {
    return this.reportId;
  }

  getInstances() {
    return this.instances;
  }
}
